import { isTokenExpired } from "../helpers/TokenHelper";
import { ICurrency } from "models/Currency.Model";
import createHttpInstance from "./http-common";

class CurrencyConvertorService {
    private serviceName = "/currencyconverter"

    async Edit(data: ICurrency) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/edit`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async Get() {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetCurrencyConvertor`).catch((err: Error) => {
            throw err?.message;
        })
    }
}

export default new CurrencyConvertorService()